<template>
    <ul
        v-if="!hasImageInEachItem"
        class="sub-menu"
    >
        <li
            v-for="(section, index) in subMenu.sections"
            :key="index"
            class="section"
        >
            <span
                v-if="section.title"
                class="item"
                @click.prevent.stop="select(section)"
            >
                {{ section.title }}
            </span>

            <SubMenuSection
                v-else
                :section="section"
                @close="close"
            />
        </li>
    </ul>

    <div
        v-else
        class="sub-menu"
    >
        <SubMenuSection
            v-for="(section, index) in subMenu.sections"
            :key="index"
            :section="section"
            @close="close"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SubMenuFragment, SubMenuSectionFragment } from '@/graphql/api'
import { hasImageInEachItem as hasImagesOnly } from '../helpers'

import SubMenuSection from '../SubMenuSection.vue'

const props = defineProps<{
    subMenu: SubMenuFragment
}>()

const emit = defineEmits<{
    select: [section: SubMenuSectionFragment]
    close: []
}>()

const select = (section: SubMenuSectionFragment) => {
    emit('select', section)
}

const hasImageInEachItem = computed(() => hasImagesOnly(props.subMenu))

const close = () => emit('close')
</script>

<style lang="scss" scoped>
.sub-menu {
    .section {
        width: 100%;

        .item {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: $slate;
            padding: 15px 20px 15px 30px;
            font-family: $effra-font-stack;
            letter-spacing: 0.05em;
            font-weight: 400;
            text-transform: uppercase;
            font-size: 0.875rem;
            line-height: 1.25rem;

            &::after {
                font-family: $icon-font;
                content: $icon-angle-right;
                font-size: 0.75rem;
            }
        }
    }
}
</style>
